import { StatTable } from "components/StatsTable/StatTable";
import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { Match } from "model/Match/Match";
import {
  MultiMmSeasonRecordWithDisplay,
  calculateMultiMmSeasonRecords,
} from "model/Records old/MultiMmSeasonRecord";
import { selectWithDisplay } from "../Shared";
import { useAppSelector } from "app/hooks";

interface Props {
  matches: Match[];
  rosterIds: string[];
  tournamentId: string;
}

export const MultiMmSeasonTable = ({
  matches,
  rosterIds,
  tournamentId,
}: Props) => {
  const records = calculateMultiMmSeasonRecords(rosterIds, matches);
  const recordsWithDisplay = useAppSelector((state) =>
    selectWithDisplay(state, records, tournamentId)
  );

  const columns: StatTableColumn<MultiMmSeasonRecordWithDisplay>[] = [
    {
      type: "Position",
      sortable: true,
      positionGetter: (arg) => arg.record.position,
    },
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.displayName,
    },
    {
      type: "Number",
      header: "Points",
      title: "Points (W-D-L, 3 for a win, 1 for a draw)",
      highlight: true,
      sortable: true,
      fractionDigits: 0,
      valueGetter: (arg) => arg.record.points,
      subTextGetter: (arg) =>
        `${arg.record.wins}-${arg.record.draws}-${arg.record.loses}`,
    },
    {
      type: "Number",
      header: "SP",
      title: "Set Points",
      sortable: true,
      fractionDigits: 1,
      valueGetter: (arg) =>
        arg.record.setPointsFor - arg.record.setPointsAgainst,
      subTextGetter: (arg) =>
        `${arg.record.setPointsFor}-${arg.record.setPointsAgainst}`,
    },
    {
      type: "Number",
      header: "RP",
      title: "Round Points",
      sortable: true,
      fractionDigits: 0,
      valueGetter: (arg) =>
        arg.record.roundPointsFor - arg.record.roundPointsAgainst,
      subTextGetter: (arg) =>
        `${arg.record.roundPointsFor}-${arg.record.roundPointsAgainst}`,
    },
  ];

  return (
    <StatTable
      thinner={true}
      stats={recordsWithDisplay}
      columns={columns}
      keyGetter={(arg) => arg.displayName}
    />
  );
};
